import { instance } from "api/apiBase";
import {
  CreateIntegrationCredentialPayload,
  IntegrationCredential,
  UpdateIntegrationCredentialPayload
} from "types/landlord/integration";

export const QUERY_INTEGRATION_CREDENTIALS = "integration_credentials";

type IntegrationCredentialsPayload = {
  integration_credentials: IntegrationCredential[];
};

export const getIntegrationCredentials =
  async (): Promise<IntegrationCredentialsPayload> =>
    (await instance.get(`/portal/v1/partners/integration_credentials`)).data;

export const createIntegrationCredential = async (
  payload: CreateIntegrationCredentialPayload
): Promise<{ integration_credential: IntegrationCredential }> =>
  (await instance.post(`/portal/v1/partners/integration_credentials`, payload))
    .data;

export const updateIntegrationCredential = async (
  id: number,
  payload: UpdateIntegrationCredentialPayload
): Promise<{ integration_credential: IntegrationCredential }> =>
  (
    await instance.patch(
      `/portal/v1/partners/integration_credentials/${id}`,
      payload
    )
  ).data;
